import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const globalSettings = {
  globalAllSettings,
  globalSettingByID,
  createGlobalSetting,
  updateGlobalSetting,
  globalSettingByElement,
};

async function globalAllSettings(filter = "") {
  let url = "/global-setting" + filter;
  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function globalSettingByID(id) {
  try {
    const response = await RestMethod.GET("/global-setting/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function globalSettingByElement(id) {
  try {
    const response = await RestMethod.GET("/global-setting/type/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function createGlobalSetting(data) {
  try {
    const response = await RestMethod.POST("/global-setting", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function updateGlobalSetting(data) {
  try {
    const response = await RestMethod.PUT("/global-setting", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
